import { render, staticRenderFns } from "./topAllshop.vue?vue&type=template&id=d4172254&scoped=true"
import script from "./topAllshop.vue?vue&type=script&lang=js"
export * from "./topAllshop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4172254",
  null
  
)

export default component.exports